// Max 32-bit signed integer, as Number.MAX_SAFE_INTEGER is possibly causing issues for Redshift "all results" queries
export const MAX_SAFE_INTEGER = 2147483647;
//# sourceMappingURL=sqlRunner.js.map